module.exports = __webpack_public_path__ + "img/login_img.ac69d67f.png";